import type { Service, TeamMember, Testimonial, Stat, NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Beranda', href: '#home' },
  { label: 'Tentang', href: '#about' },
  { label: 'Pendanaan Bisnis', href: '#funding' },
  { label: 'Produk & Layanan', href: '/produk-layanan' },
  { label: 'Tim', href: '#team' },
  { label: 'Testimoni', href: '#testimonials' },
  { label: 'Kontak', href: '#contact' },
];

export const services: Service[] = [
  {
    id: 1,
    title: 'Business Plan & Feasibility Study',
    description: 'Rencana bisnis komprehensif dan studi kelayakan untuk memastikan keberhasilan investasi Anda dengan analisis mendalam.',
    icon: 'ClipboardList',
  },
  {
    id: 2,
    title: 'Market & Marketing Research',
    description: 'Riset pasar profesional untuk memahami target audience, kompetitor, dan peluang pasar yang tersedia.',
    icon: 'TrendingUp',
  },
  {
    id: 3,
    title: 'Finance, Tax & Accounting',
    description: 'Layanan keuangan, perpajakan, dan akuntansi untuk kesehatan finansial bisnis Anda.',
    icon: 'Calculator',
  },
  {
    id: 4,
    title: 'Business Proposal & Pitch Deck',
    description: 'Proposal bisnis profesional dan pitch deck yang menarik untuk investor dan stakeholder.',
    icon: 'Presentation',
  },
  {
    id: 5,
    title: 'Business Advisory',
    description: 'Konsultasi bisnis strategis dari ahli berpengalaman untuk mengoptimalkan operasional Anda.',
    icon: 'Users',
  },
  {
    id: 6,
    title: 'ERP Solutions & Business Automation',
    description: 'Solusi sistem informasi bisnis modern untuk efisiensi dan transformasi digital.',
    icon: 'Monitor',
  },
  {
    id: 7,
    title: 'Business Strategy Development & Audit',
    description: 'Pengembangan strategi bisnis dan audit komprehensif untuk peningkatan berkelanjutan.',
    icon: 'Target',
  },
  {
    id: 8,
    title: 'Human Resource Planning & Training',
    description: 'Perencanaan SDM dan program pelatihan untuk membangun tim yang kuat dan kompeten.',
    icon: 'GraduationCap',
  },
  {
    id: 9,
    title: 'Industry & Economic Analysis',
    description: 'Analisis industri dan ekonomi domestik maupun global untuk perencanaan strategis.',
    icon: 'Globe',
  },
  {
    id: 10,
    title: 'Funding Advisory & Channeling Service',
    description: 'Akses pendanaan dari bank, investor, dan alternatif financing dengan struktur keuangan yang bankable.',
    icon: 'DollarSign',
  },
];

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: 'Eurwin Chandra',
    role: 'Senior Business Associate',
    image: '/team/eurwin.jpg',
    linkedin: 'https://www.linkedin.com/in/eurwin-chandra-94b3b1121',
    bio: 'Lahir di kota Surabaya, Memiliki pengalaman mendalam di industri Retail & FMCG dan riset pasar. Selama kariernya, ia telah berkontribusi di beberapa perusahaan besar, termasuk WINGS GROUP, di mana ia mengembangkan berbagai strategi riset pasar untuk membantu meningkatkan performa produk dan mengidentifikasi tren konsumen. Selain itu, beliau juga memiliki pengalaman sebagai Marketing Strategist di PT HM Sampoerna, di mana ia terlibat langsung dalam merancang dan mengeksekusi strategi pemasaran yang berfokus pada pertumbuhan bisnis dan peningkatan brand awareness serta penetrasi penjualan. Dengan keahlian beliau dalam analisis data, pemetaan pasar, dan perilaku konsumen yang berperan penting dalam memberikan insight strategis yang berharga bagi berbagai klien & proyek bisnis yang dikerjakannya. Dengan kombinasi pengalamannya di perusahaan besar dan pemahaman mendalam tentang pasar, beliau siap membantu bisnis Anda dalam meraih peluang baru dan membuat keputusan berdasarkan data yang kuat.',
  },
  {
    id: 2,
    name: 'Daniel Nugraha',
    role: 'Founder & CEO',
    image: '/team/daniel.jpg',
    linkedin: 'https://www.linkedin.com/in/daniel2710',
    bio: 'Seorang profesional yang telah mengukir pengalaman lebih dari 5 tahun di industri manufaktur dan ekspor. Kariernya dimulai di berbagai posisi strategis di sektor ini, yang membentuk dasar kuat untuk keterampilannya dalam manajemen operasional dan ekspor komoditi. Di tahun 2021, beliau menjabat sebagai Operational Manager di PT TANI KONJAC INDONESIA, perusahaan manufaktur hasil bumi. Dalam perannya ini, Beliau bertanggung jawab atas seluruh rantai produksi, mulai dari penerimaan bahan baku hingga menghasilkan produk jadi dan perencanaan managerial. Beliau juga menjabat sebagai komisaris di CV BUMI ANUGERAH JAYA, perusahaan yang bergerak di sektor ekspor komoditi hasil bumi di mana ia menangani dan mendireksikan berbagai aspek penting seperti Ekspor, logistik, warehousing, hingga Quality control. Pengalaman ini memberinya wawasan mendalam tentang manajemen rantai pasok dan standar kualitas produk yang dibutuhkan untuk pasar internasional. Dengan fondasi pengalaman yang solid, pada tahun 2023 beliau mendirikan Emporium Solution untuk membantu UMKM dalam mengembangkan strategi bisnis yang efektif, berdasarkan data dan riset yang mendalam.',
  },
  {
    id: 3,
    name: 'Fajri Nur Winda',
    role: 'Market Researcher',
    image: '/team/fajri.jpg',
    linkedin: 'https://www.linkedin.com/in/fajrinurwinda',
    bio: 'Lulusan Ekonomi Pembangunan yang berpengalaman di bidang riset, analisis data, dan administratif. Memiliki keahlian dalam riset pasar, pengolahan data, serta administrasi keuangan, dengan pendekatan berbasis data untuk mendukung pengambilan keputusan bisnis. Kariernya mencakup berbagai pengalaman profesional, mulai dari bekerja sebagai Staff Administrasi di PT Garindo Food International, di mana ia bertanggung jawab atas laporan keuangan, rekonsiliasi utang piutang, serta pencatatan transaksi menggunakan Accurate Enterprise. Selain itu, ia juga memiliki pengalaman sebagai Teller di Bank Central Asia (BCA) serta magang di Bea Cukai Tanjung Emas Semarang, pengalaman tersebut memperkuat pemahamannya dalam manajemen keuangan dan administrasi. Di bidang akademik, ia pernah berkontribusi sebagai Admin Jurnal di Universitas Negeri Semarang, yang mengelola publikasi ilmiah ekonomi dan mengoordinasikan pengumpulan artikel dari berbagai peneliti. Ia juga aktif dalam riset dan pernah mempresentasikan hasil penelitian dalam konferensi ekonomi serta perlombaan karya ilmiah di ajang nasional. Sebagai Market Researcher, ia telah membantu berbagai bisnis dalam menganalisis tren industri, memahami perilaku konsumen, serta mengolah data menjadi insight strategis yang mendukung pengambilan keputusan. Dengan latar belakang yang kuat dalam bidang riset dan analisis data, ia beraspirasi untuk memberikan insight yang akurat dan relevan bagi bisnis yang ingin berkembang di pasar yang kompetitif.',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Bapak Hendri',
    position: 'Direktur Utama',
    company: 'CV Bumi Anugerah Jaya',
    quote: 'Tim Emporium sudah membantu banyak dalam merombak system kerja yang ideal agar bisnis kami tidak boros biaya, tim juga membantu membuatkan sistem pencatatan dan dashboard sehingga saya bisa mengontrol dan mengevaluasi kerja yang biasa menggunakan tracking manual.',
    logo: '/bumi-anugerah-jaya.png',
    rating: 5,
  },
  {
    id: 2,
    name: 'Bapak Rama Damanik',
    position: 'Project Coordinator',
    company: 'Deo Airport Sorong',
    quote: 'Saya puas dengan kualitas dan detail analisis kelayakan proyek parking management kami, Pak Daniel dan tim tidak hanya memberikan gambaran ekspektasi bisnis dan potensi bagaimana bisnis dikembangkan tapi juga saran dan rekomendasi yang penuh angka spesifik sehingga kami mendapat bayangan tolak ukur keberhasilan proyek dan mampu merencanakan proyek kedepan.',
    logo: '/deo-airport.png',
    rating: 5,
  },
  {
    id: 3,
    name: 'Kurniawan Ati',
    position: 'Entrepreneur',
    company: 'Cireng Keraton',
    quote: 'Tim Emporium memberikan hasil riset pasar berbasis data dengan detail dan memberi saya arahan bagaimana melakukan positioning branding dan go-to-market strategi yang detail hingga usaha saya saat ini berjalan cukup baik sudah lebih dari 5 bulan.',
    logo: '/cireng-keraton.png',
    rating: 5,
  },
  {
    id: 4,
    name: 'Bapak Wiyan',
    position: 'Marketing Supervisor',
    company: 'Berman Construction',
    quote: 'Kami terbantu sekali karena kami dapat mencapai target penjualan usaha kami untuk ekspansi pasar ke Bandung dalam 6 bulan. Emporium memberi banyak masukan yang tepat sasaran sesuai dengan kebutuhan pasarnya melalui produk Business Plan.',
    logo: '/berman.png',
    rating: 5,
  },
  {
    id: 5,
    name: 'Willie',
    position: 'Founder',
    company: 'Pusatinvestasi.id',
    quote: 'Sistem CRM yang dibuat oleh tim Emporium keren dan efektif untuk penjualan produk digital kami, Emporium membantu riset keyword dan system layanan pelanggan yang scalable, jadi sekarang kami punya kapasitas lebih dalam menghandling pelanggan.',
    logo: '/pusatinvestasi.png',
    rating: 5,
  },
];

export const stats: Stat[] = [
  { id: 1, value: '300', label: 'Masalah Bisnis Terpecahkan', suffix: '+' },
  { id: 2, value: '2022', label: 'Beroperasi Semenjak Tahun', suffix: '' },
  { id: 3, value: '12', label: 'Associate Berpengalaman', suffix: '+' },
  { id: 4, value: '15', label: 'Sektor Industri', suffix: '+' },
  { id: 5, value: '87', label: 'Klien Puas', suffix: '%' },
];

export const companyInfo = {
  name: 'Emporium Solution',
  tagline: 'Solusi Bisnis & Pasar Ramah',
  address: 'Jl. Dr. Ir. H. Soekarno No.470, Kedung Baruk, Kec. Rungkut, Surabaya, Jawa Timur 60298',
  description: 'Membantu 300+ bisnis sejak tahun 2022 di bidang IT, Manufaktur, F&B, Pariwisata, Konstruksi & Retail',
  email: 'info@emporiumsolution.id',
  phone: '+62 813-5799-6789',
  whatsapp: '+62 813-5799-6789',
};